<template>
  <div class="service" id="">
    <div class="container">
      <customeTitle
        :smallTitle="i18n('services.srv')"
        :title="i18n('services.title')"
        :description="i18n('services.note')"
      />
      <div class="services-container">
        <div
          v-for="(service, index) in services"
          :key="index"
          class="service-card-container"
        >
          <div
            data-aos="fade-up"
            :data-aos-delay="index * 150"
            data-aos-easing="ease-in-out"
            class="service-card stretched-link"
          >
            <div>
              <div class="icon-container">
                <i :class="service.icon"></i>
              </div>
              <h5 class="card-title">{{ i18n(service.title) }}</h5>
              <p class="card-description">{{ i18n(service.description) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import customeTitle from "./customeTitle.vue";

export default {
  name: "AboutExpand",
  data() {
    return {
      services: [
        {
          icon: "fas fa-industry",
          title: "services.card1.title",
          description: "services.card1.description",
          link: `/${this.$i18n.locale}/Industrial`,
        },
        {
          icon: "fas fa-gas-pump",
          title: "services.card2.title",
          description: "services.card2.description",
          link: `/${this.$i18n.locale}/FishFarming`,
        },
        {
          icon: "fas fa-fish",
          title: "services.card3.title",
          description: "services.card3.description",
          link: `/${this.$i18n.locale}/MarineNavy`,
        },
        {
          icon: "fas fa-ship",
          title: "services.card4.title",
          description: "services.card4.description",
          link: `/${this.$i18n.locale}/OilSpill`,
        },
        {
          icon: "fas fa-oil-can",
          title: "services.card5.title",
          description: "services.card5.description",
          link: `/${this.$i18n.locale}/Pumps`,
        },
        {
          icon: "fas fa-tachometer-alt",
          title: "services.card6.title",
          description: "services.card6.description",
          link: `/${this.$i18n.locale}/Pumps`,
        },
      ],
    };
  },
  methods: {
    goToPage(link) {
      this.$router.push(link);
    },
    i18n(key, args) {
      return this.$t(key, args);
    },
    handleTranslation(title) {
      if (title === "Industrial and Petroluem")
        return this.i18n("services.ind");
      if (title === "Fish Farming") return this.i18n("services.fish");
      if (title === "Marine and Navy") return this.i18n("services.marine");
      if (title === "Oil Spill Combating") return this.i18n("services.oil");
      if (title === "Pumps") return this.i18n("services.pump");
    },
  },
  components: {
    customeTitle,
  },
};
</script>
  <style scoped lang="scss">
.font-bold {
  font-weight: bold !important;
}
.service {
  background: #f5f5f549;
  padding-top: 100px;
  padding-bottom: 100px;
}
.services-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 30px;
  margin-top: 40px;
}
.service-card {
  position: relative;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border-radius: 0.3rem;
  transition: all 0.1s ease-in;
  box-shadow: 0px 10px 22px rgba(0, 0, 0, 0.081);
  min-height: 316px;
}
.service-card::after {
  content: "";
  position: absolute;
  top: 1px;
  right: 0%;
  left: 0%;
  margin-left: auto;
  margin-right: auto;

  width: 0px;
  height: 3px;
  background: #122b50;
  transition: all 0.3s ease-in-out;
}
.service-card:hover::after {
  width: 100%;
}
.service-card-container {
  transition: all 0.3s ease-in-out;
}
.service-card-container:hover {
  transform: translateY(-10px);
}
.card-title {
  font-size: 20px;
  margin: 10px 0px;
}
.card-description {
  font-size: 15px;
  color: #8492a6;
}
.icon-container {
  font-size: 35px;
  color: #113e86;
}
</style>
  <style lang='scss'>
.stretched-link:hover {
  color: #0a306c !important;
}

.service-card:nth-child(2) {
  box-shadow: 0px 10px 22px rgba(0, 0, 0, 0.081);
}
.service-card:nth-child(4) {
  box-shadow: 0px 10px 22px rgba(0, 0, 0, 0.081);
}
.service-card:nth-child(6) {
}
</style>